import React from 'react'
import FaqContainer from './FaqContainer'
import s from './Faq.less'
import FaqItem from './FaqItem'
import { insertLinkInText } from './faq.helpers'
import { replaceKeysInString } from '../../../utils/string'
import { useSelector } from 'react-redux'
import { selectCurrentHistoryFullRoute } from '../../../store/history/history.selectors'
import { selectCmsFaq, selectCmsFaqTitle } from '../../../store/seo/seo.selectors'
import useErrorBoundaryCallback from '../../utils/useErrorBoundaryCallback'

const Faq = ({ faqParams = {}, impressionDataTag, clickDataTag, title = true, text = false }) => {
  const currentRouteURL = useSelector(selectCurrentHistoryFullRoute)
  const faqTitle = useSelector(selectCmsFaqTitle)
  const faq = useSelector(selectCmsFaq)

  const insertFaqParams = useErrorBoundaryCallback(text => replaceKeysInString(text, faqParams), [faqParams])

  if (!faq) return <></>

  return (
    <FaqContainer impressionDataTag={impressionDataTag}>
      {text && <div className={s.text}>{insertFaqParams(faqTitle)}</div>}
      {title && <h2 className={s.title}>{insertFaqParams(faqTitle)}</h2>}

      {faq.map(({ question, answer }, index) => {
        const computedAnswer = insertLinkInText({
          txt: insertFaqParams(answer),
          currentRouteURL
        })

        return (
          <FaqItem
            key={index}
            question={insertFaqParams(question)}
            answer={computedAnswer}
            clickDataTag={clickDataTag}
          />
        )
      })}
    </FaqContainer>
  )
}

export default Faq
